import {Route} from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import {lazy} from "react";

const ReferenceBookLabWorkingHours = lazy(() => import("@/pages/ReferenceBooks/Lists/WorkingHours/ReferenceBookLabWorkingHours"));
const ReferenceBookStaffWorkingHours = lazy(() => import("@/pages/ReferenceBooks/Lists/WorkingHours/ReferenceBookStaffWorkingHours"));

const urlsConfig = new UrlsConfig();

export function referenceBookWorkingHoursRoutes() {
    return (
      <>
          <Route
            path={urlsConfig.referenceBookLabWorkingHours.to}
            element={<ReferenceBookLabWorkingHours/>}
          />
          <Route
            path={urlsConfig.referenceBookStaffWorkingHours.to}
            element={<ReferenceBookStaffWorkingHours/>}
          />
      </>
    );
}
